document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (!button) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Could not add item');
        button.textContent = 'Added ✓';
        setTimeout(() => window.location.reload(), 500);
      } catch (error) {
        button.textContent = 'Try again';
        button.disabled = false;
        setTimeout(() => { button.textContent = original; }, 1600);
      }
    });
  });
});
